// Error codes and their handling configurations
export const ERROR_CODES = {
  STOCK_PAUSED_WITH_PAUSE_AFTER: {
    code: "STOCK_PAUSED_WITH_PAUSE_AFTER",
    type: "stock_pause",
    getMessage: (_, count = 1) => {
      if (count === 1) {
        return `A product is not available. Please remove it from cart to continue.`;
      } else {
        return `${count} products are not available. Please remove them from cart to continue.`;
      }
    }
  },
};

// Helper function to get error message by code
export const getErrorMessage = (errorCode, errorData, count = 1) => {
  const errorConfig = ERROR_CODES[errorCode];
  if (errorConfig && errorConfig.getMessage) {
    return errorConfig.getMessage(errorData, count);
  }
  return "An error occurred. Please try again.";
};
